import React, { Component } from 'react'

class ContactText extends Component {
  constructor (props) {
    super(props)
    this.formName = props.formName
  }

  render() {
    if (this.formName === "Contact") {
      return (
        <div className="contact-text">
          <h4>VOLUNTEERS:</h4>
            <p>Your skillset and passion might just be what we need. Please check out our volunteer opportunity listings to get involved.</p>
          <h4>  SPONSORS:</h4> 
            <p>If you support the ideas that Mind Makers promotes and you want to sponsor this initiative, please reach out and let us collaborate. You will help make STEM education and mentorship accesssible and inspiring to people of all ages from all walks of life, and to paint a new picture of engineers and engineering. As a 501(C)(3) (pending) organization, your contribution to Mind Makers will also be tax deductible.</p>
          <h4>MIND MAKERS ALLIES:</h4>
          <p>If you vibe with our mission and you think we will align with the mission of your organization too, please reach out. We will do more good by empowering each other through our mutual collaboration and support.</p>
          <p>Any additional comments, inquiries, or support are also welcome. We will all thrive with your support.</p>
        </div>
      )
    }
    return null;
  }
}

export default ContactText



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactText.js